import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

const MyPreset = definePreset(Material, {
  primitive: {
    fontFamily: 'inherit',
    blue: {
      50: '#f4fafe',
      100: '#cae6fc',
      200: '#a0d2fa',
      300: '#75bef8',
      400: '#4baaf5',
      500: '#2196f3',
      600: '#1c80cf',
      700: '#1769aa',
      800: '#125386',
      900: '#0d3c61',
      950: '#08263d',
    },
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}', // Color principal
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

export default MyPreset;
